
import AppData from '../../../Model/MerchantAppData';
const _instances = {}
let _instance = null

export default class OrderRepository {
    /**
     * @return {OrderRepository}
     */
    static get instance() {
        if (!_instance) {
            _instance = new OrderRepository(AppData.data)
        }
        return _instance
    }
    constructor(app) {
        this.app = app
    }
    updateOrder(order, callback) {
        order['update_order'] = true
        $.ajax({
            url     : `/merchant/api/order/${order.id}/update`,
            type    : 'post',
            data    : order,
            success : (updatedOrder) => {
                callback && callback(updatedOrder)
            }
        })
    }

    copyAllOrders(tableSessionId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchants/orders/copy`,
                type    : 'post',
                data    : {
                    table_session_id: tableSessionId,
                },
                success : (res) => {
                    console.log(res)
                    resolve(res)
                }
            })
        })
    }
}